'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _documentOffset = require('document-offset');

var _documentOffset2 = _interopRequireDefault(_documentOffset);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this.state = {
            verticalScroll: false,
            horizontalScroll: false,
            active: false,
            hover: false,
            direction: 'down',
            horizontalDirection: 'left',
            maxHeight: null,
            maxWidth: null
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value instanceof Array) {
                var list = [],
                    changed = void 0,
                    newValue = [];

                if (nextProps.collection) {
                    list = nextProps.collection;
                    list = list.map(function (model) {
                        return model.id;
                    });
                } else if (nextProps.children) {
                    list = _react2.default.Children.toArray(nextProps.children);
                    list = list.map(function (el) {
                        return el.props.value;
                    });
                }

                nextProps.value.forEach(function (item) {
                    if (list.indexOf(item) >= 0) {
                        newValue.push(item);
                    } else {
                        changed = true;
                    }
                });

                if (changed) {
                    this.value = newValue;
                }
            }

            return this;
        }
    }, {
        key: 'isUiActive',
        value: function isUiActive() {
            return this.state.active;
        }
    }, {
        key: 'open',
        value: function open() {
            var _this2 = this;

            if (this.props.readOnly || this.props.disabled) {
                return Promise.resolve();
            }

            if (this.state.active) {
                return this.close();
            }

            var list = this._getCollection();

            if (list && list.length) {
                this.docH = window.document.documentElement.offsetHeight;
                this.docW = window.document.documentElement.offsetWidth;

                this.setState({
                    active: true,
                    verticalScroll: list.length > this.props.maxLength
                }).then(function () {
                    _this2._setPosition();
                });
            }

            return this;
        }
    }, {
        key: '_handleBodyClick',
        value: function _handleBodyClick() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.state.active && !this.root.contains(event.target)) {
                this.close();
            }

            return this;
        }
    }, {
        key: '_getCollection',
        value: function _getCollection() {
            return this.props.collection || this.props.children;
        }

        /**
         * Обновляем позицию выпадающего списка
         * @return {object}
         */

    }, {
        key: '_setPosition',
        value: function _setPosition() {
            var listOffset = void 0,
                listH = this.list.offsetHeight,
                listW = this.list.offsetWidth,
                rootWidth = this.root.offsetWidth,
                rootHeight = this.root.offsetHeight,
                direction = 'down',
                horizontalDirection = 'left',
                maxWidth = null,
                maxHeight = null,
                availTop = void 0,
                availBottom = void 0,
                availRight = void 0,
                availLeft = void 0,
                verticalScroll = this.state.verticalScroll,
                horizontalScroll = this.state.horizontalScroll;

            listOffset = (0, _documentOffset2.default)(this.list);

            availTop = listOffset.top - rootHeight - 8;
            availBottom = this.docH - listOffset.top - 8;
            availLeft = listOffset.left + rootWidth - 8;
            // minimal padding + scroll
            availRight = this.docW - listOffset.left - 24;

            if (listOffset) {
                // вылазит на нижнюю границу документа
                if (availBottom < listH) {
                    var maxAvailHeight = void 0;

                    direction = availBottom > availTop ? 'down' : 'up';
                    maxAvailHeight = direction === 'down' ? availBottom : availTop;

                    // список не влазит по высоте ни в каком случае
                    if (listH > maxAvailHeight) {
                        maxHeight = maxAvailHeight + 'px';
                        verticalScroll = true;
                    }
                }

                // вылазит за правую границу документа
                if (availRight < listW) {
                    var maxAvailWidth = void 0;

                    horizontalDirection = availLeft > availRight ? 'right' : 'left';
                    maxAvailWidth = horizontalDirection === 'right' ? availLeft : availRight;

                    // по горизонтали не помещается ни в каком случае
                    if (listW > maxAvailWidth) {
                        maxWidth = maxAvailWidth + 'px';
                        horizontalScroll = true;
                    }
                }
            }

            return this.setState({
                direction: direction,
                horizontalDirection: horizontalDirection,
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                horizontalScroll: horizontalScroll,
                verticalScroll: verticalScroll
            });
        }
    }, {
        key: 'select',
        value: function select(value) {
            var checked = this.props.value && this.props.value.indexOf(value) >= 0,
                nextValue = [].concat(this.props.value);

            if (checked) {
                // make uncheck
                nextValue = nextValue.filter(function (item) {
                    return item !== value;
                });
            } else {
                nextValue.push(value);
            }

            this.value = nextValue;
            var list = this._getCollection();

            if (list && list.length === nextValue.length) {
                return this.close().then(function () {
                    return Promise.resolve();
                });
            } else {
                Promise.resolve();
            }
        }

        /**
         * пришлось ставить задержку потому что Chrome генерит 2 события на button, которые нельзя остановить через stopPropagation
         * firefox в свою очередь не реагирует на клик по вложенному чекбоксу, от чего м ыне может завязаться на него
         * @private
         * @return {object}
         */

    }, {
        key: '_handleSelect',
        value: function _handleSelect() {
            var _this3 = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            this._selectDelayTimeout && clearTimeout(this._selectDelayTimeout);
            this._selectDelayTimeout = setTimeout(function () {
                return _this3.select.apply(_this3, args);
            }, 10);
            return this;
        }
    }, {
        key: '_handleBlur',
        value: function _handleBlur(event) {
            var relatedTarget = void 0;

            // Firefox not supported relativeEvent
            if (event.relatedTarget !== null) {
                relatedTarget = event.relatedTarget;

                // hack for firefox. returns some like event.target, but more strict.
            } else if (event.nativeEvent && event.nativeEvent.explicitOriginalTarget) {
                relatedTarget = event.nativeEvent.explicitOriginalTarget;
            }

            // блюр срабатывает так же при выборе элемента из списка, в таком случае нам не нужна обработка введенных в инпут данных
            if (!this.root.contains(relatedTarget)) {
                this.close();
            }

            return this;
        }
    }, {
        key: '_handleFocusList',
        value: function _handleFocusList() {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.isUiActive() && (event.keyCode === 40 || event.keyCode === 38)) {
                this.focusList(event.keyCode === 40);
            }

            return this;
        }
    }, {
        key: '_keymap',
        value: function _keymap(event, id) {
            if (event.keyCode === 40 || event.keyCode === 38) {
                event.preventDefault();

                var items = this.list.querySelectorAll('[role="multi-select-item"]'),
                    focused = Array.prototype.find.call(items, function (node) {
                    return window.document.activeElement === node;
                }),
                    focusedIndex = Array.prototype.indexOf.call(items, focused);

                if (event.keyCode === 40) {
                    if (items.length && items[focusedIndex + 1]) {
                        items[focusedIndex + 1].focus();
                    } else if (items.length) {
                        items[0].focus();
                    }
                } else {
                    if (items.length && items[focusedIndex - 1]) {
                        items[focusedIndex - 1].focus();
                    } else if (items.length) {
                        items[items.length - 1].focus();
                    }
                }
            }

            if (event.keyCode === 32) {
                this.select(id);
            }

            return this;
        }
    }, {
        key: '_handleHover',
        value: function _handleHover() {
            return this.setState({ hover: true });
        }
    }, {
        key: '_handleRootBlur',
        value: function _handleRootBlur() {
            return this.setState({ hover: false });
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.disabled || this.props.readOnly) + String(this.state.active) + String(this.state.hover) + String(this.state.verticalScroll) + String(this.state.direction) + String(this.state.horizontalDirection) + String(this.state.maxWidth) + String(this.state.maxHeight) + String(this.props.inline) + String(this.props.error);
        }
    }, {
        key: 'close',
        value: function close() {
            return this.setState({
                active: false,
                direction: 'down',
                horizontalDirection: 'left',
                maxHeight: null,
                maxWidth: null,
                horizontalScroll: false,
                verticalScroll: false
            });
        }

        /**
         * focus list
         * @param {boolean} first - true|false
         * @return {object}
         */

    }, {
        key: 'focusList',
        value: function focusList() {
            var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var items = this.list.querySelectorAll('[role="multi-select-item"]');

            if (first && items.length) {
                items[0].focus();
            } else if (items.length) {
                items[items.length - 1].focus();
            }

            return this;
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.nativeElement.focus();
            return this;
        }
    }, {
        key: '_listRef',
        value: function _listRef(el) {
            this.list = el;
        }
    }, {
        key: '_rootRef',
        value: function _rootRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.root = el;
        }
    }, {
        key: '_nativeRef',
        value: function _nativeRef(el) {
            this.nativeElement = el;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            var target = void 0,
                event = void 0;

            target = Object.assign({}, this, {
                value: value
            });

            event = {
                target: target,
                currentTarget: target,
                preventDefault: preventDefault,
                stopPropagation: stopPropagation,
                type: 'change'
            };

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event);
            }
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    // max length of list
    maxLength: 12,
    // components label
    label: '',
    // components placeholder
    placeholder: '',
    // onChange callback
    onChange: null,
    inline: false
};
Main.propTypes = {
    label: _propTypes2.default.string,
    placeholder: _propTypes2.default.string
};
Main.displayName = 'MultiSelect';
exports.default = Main;